const ksdecodeEmail = (encoded) => {
  let decoded = '';
  for (let i = 0; i < encoded.length; i++) {
    decoded += String.fromCharCode(encoded.charCodeAt(i) - 1);
  }
  return decoded;
}
const ks_mlinkto = (encoded) => {
  let decoded = '';
  decoded = ksdecodeEmail(encoded);
  window.location.href = 'mailto:' + decoded;
}
const initEmailAddress = (eleClass) => {
  console.log('init_email_address.jsv');
  let emailLinks = document.querySelectorAll(eleClass);
  emailLinks.forEach(function (link) {
    let encodedEmail = link.getAttribute('data-enco-email');
    link.href = 'javascript:ks_mlinkto(\'' + encodedEmail + '\')';
    // link.innerHTML = ksdecodeEmail(encodedEmail).replace('@', '[at]').replace('.de', '[dot]de ');
    link.innerHTML = ksdecodeEmail(encodedEmail);
  });
  window.ks_mlinkto = ks_mlinkto;
};

export default initEmailAddress;
